<template>
  <div>
    <b-form-group>
      <b-button
        :disabled="disabled"
        variant="outline-secondary"
        @click="showModal = true">
        <i class="fas fa-plus"></i>
        Add Groups
      </b-button>
      <br>
      {{ taggedGroups.length }} tagged
      <br>
    </b-form-group>

    <b-modal
      v-model="showModal"
      title="Groups"
      centered hide-footer
      size="lg">
      <groups-table
        v-if="showModal"
        :view="view"
        :ids-to-highlight="taggedGroups"
        context="select"
        @removeAll="removeAll"
        @selectGroup="addGroupRelation"/>
      <b-button
        variant="outline-primary"
        class="mt-3"
        block
        @click="showModal = false">
        Done Selecting
      </b-button>
    </b-modal>

  </div>
</template>

<script>
import groupsTable from './table'
import { mapState } from 'vuex'

export default {
  components: {
    groupsTable
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    initialGroups: {
      type: Array,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      taggedGroups: []
    }
  },
  computed: {
    ...mapState('groups', {
      view: '_defaultView'
    }),
    groups () {
      return this.$store.getters['groups/view'](this.view)
    }
  },
  mounted () {
    this.taggedGroups = this.initialGroups
    this.updateStore()
  },
  methods: {
    updateStore () {
      this.$store.commit(`${this.namespace}/forms/relateGroups/setField`, {
        field: 'groupIDs',
        value: this.taggedGroups
      })
    },
    removeAll () {
      this.taggedGroups = []
      this.updateStore()
    },
    addGroupRelation (group) {
      // toggle inclusion of groups
      let idx
      let exists = false
      for (let i=0; i<this.taggedGroups.length; i++) {
        if (this.taggedGroups[i] === group.id) {
          exists = true
          idx = i
        }
      }

      if (exists) {
        this.taggedGroups.splice(idx, 1)
      } else {
        this.taggedGroups.push(group.id)
      }

      this.updateStore()
    },
    reset (event) {
      this.taggedGroups = this.initialGroups
      this.$store.commit(`${this.namespace}/forms/relateGroups/resetState`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/groups/relateGroups.vue